// extracted by mini-css-extract-plugin
export default {"main":"PageContainer_main__3yY5q","background":"PageContainer_background__Lx7w4"};